/** EPR Packaging SKU section — Shopify-app analog on the Lappa platform. */

export const PACKAGING_SKU_PATH = "/packaging-sku"
